module.exports = __webpack_public_path__ + "img/icon_group_web.d9781a0c.svg";